import { render, staticRenderFns } from "./DatasetSelection.vue?vue&type=template&id=91645256&scoped=true"
import script from "./DatasetSelection.vue?vue&type=script&lang=js"
export * from "./DatasetSelection.vue?vue&type=script&lang=js"
import style0 from "./DatasetSelection.vue?vue&type=style&index=0&id=91645256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91645256",
  null
  
)

export default component.exports